<div class="naplo-tartalom" *ngIf="aktiv.ugyfelId; else nincsUgyfel">

  <app-uzemszunet-sav forras="eonkormanyzat"></app-uzemszunet-sav>

  <div class="naplo-eszkozsor">
    <ion-button fill="solid" style="--background:var(--naplo)" (click)="ujHozzar()">
      <ion-icon slot="start" name="add"></ion-icon> Önkormányzat hozzárendelése
    </ion-button>
    <ion-button fill="outline" color="success" (click)="szinkron()" [disabled]="!hozzarendelt.length">
      <ion-icon slot="start" name="sync"></ion-icon> Mind szinkronizálása
    </ion-button>
    <ion-button fill="clear" size="small" (click)="captchaMutat = !captchaMutat"
                title="A szerepkörváltás Turnstile-jához használt solver API-kulcsa">
      <ion-icon slot="start" name="shield-checkmark"></ion-icon> Solver
    </ion-button>
  </div>

  <!--  Captcha-solver beállítás (a szerepkörváltás Cloudflare Turnstile-jához).
        A kulcsot egyszer kell megadni, utána csak zavar a napi munkában – ezért alapból rejtve
        van, és a fenti „Solver" gombbal hozható elő, ha cserélni kell. -->
  <div class="onk-kartya" style="margin-top:8px" *ngIf="captchaMutat">
    <h3><ion-icon name="shield-checkmark"></ion-icon> Turnstile-solver
      <small>{{ captcha.hasKey ? '· beállítva' : '· nincs API-kulcs' }}</small>
    </h3>
    <div style="display:flex; gap:10px; flex-wrap:wrap; align-items:flex-end">
      <ion-item style="min-width:200px">
        <ion-label position="stacked">Szolgáltató</ion-label>
        <ion-select [(ngModel)]="captcha.provider" interface="popover">
          <ion-select-option value="2captcha">2captcha</ion-select-option>
          <ion-select-option value="capsolver">CapSolver</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item style="flex:1; min-width:260px">
        <ion-label position="stacked">API-kulcs {{ captcha.hasKey ? '(mentve – csak cseréhez töltsd ki)' : '' }}</ion-label>
        <ion-input type="password" [(ngModel)]="captcha.apiKey" placeholder="a solver API-kulcsa"></ion-input>
      </ion-item>
      <ion-button fill="outline" (click)="captchaMent()"><ion-icon slot="start" name="save"></ion-icon> Mentés</ion-button>
    </div>
    <p class="halvany" style="margin:6px 4px 0">A bejelentkezés + adóegyenleg-lekérdezés automata; a szerepkörváltás Cloudflare Turnstile-ját a kiválasztott solver oldja meg.</p>
  </div>

  <!-- Hozzárendelt önkormányzatok -->
  <div class="tabla-wrap" *ngIf="hozzarendelt.length; else nincsOnk">
    <table class="naplo-tabla">
      <thead><tr><th>Önkormányzat</th><th>Szerepkör</th><th>Fiók (ügyfélkapu+)</th><th>Adóazonosító</th><th>Utolsó szinkron</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let h of hozzarendelt" [style.opacity]="h.aktiv ? 1 : .5">
          <td>{{ h.onkormanyzat_nev }}</td>
          <td>
            <span *ngIf="h.szerepkor === 'ceg'">Cég</span>
            <span *ngIf="h.szerepkor === 'egyeni'">Egyéni váll.</span>
            <span *ngIf="h.szerepkor === 'maganszemely'">Magánszemély</span>
            <span *ngIf="!h.szerepkor" style="color:#b45309">— nincs beállítva</span>
            <div *ngIf="h.szerepkor_nev" style="font-size:.75rem; color:#64748b">{{ h.szerepkor_nev }}</div>
          </td>
          <td>{{ h.fiok_cimke || '—' }}</td>
          <td>{{ h.adoazonosito || '—' }}</td>
          <td>{{ h.utolso_szinkron || '—' }}</td>
          <td style="white-space:nowrap">
            <ion-button size="small" fill="clear" color="success" (click)="szinkron(h)" title="Szinkron"><ion-icon slot="icon-only" name="sync"></ion-icon></ion-button>
            <ion-button size="small" fill="clear" *ngIf="h.pdf_object" color="warning" (click)="pdf(h)" title="PDF kivonat"><ion-icon slot="icon-only" name="reader"></ion-icon></ion-button>
            <ion-button size="small" fill="clear" (click)="szerkeszt(h)" title="Szerkesztés"><ion-icon slot="icon-only" name="create"></ion-icon></ion-button>
            <ion-button size="small" fill="clear" color="danger" (click)="torol(h)" title="Törlés"><ion-icon slot="icon-only" name="trash"></ion-icon></ion-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #nincsOnk>
    <div class="ures"><ion-icon name="business-outline"></ion-icon> Még nincs hozzárendelt önkormányzat. Vedd fel, melyik adófolyószámlákat szinkronizáljuk ennek az ügyfélnek.</div>
  </ng-template>

  <!-- Szinkronizált adófolyószámlák -->
  <div *ngFor="let o of egyenlegek" class="onk-kartya">
    <h3><ion-icon name="business"></ion-icon> {{ o.onkormanyzat_nev }}
      <small *ngIf="o.utolso_szinkron">· {{ o.utolso_szinkron }}</small>
      <ion-button size="small" fill="clear" color="warning" *ngIf="o.pdf_object" (click)="pdf(o)"><ion-icon slot="start" name="reader"></ion-icon> PDF</ion-button>
    </h3>
    <table class="naplo-tabla" *ngIf="o.egyenlegek?.length">
      <thead><tr><th>Adónem</th><th>Számlaszám</th><th>Befizetőazonosító</th><th class="num">Tartozás</th><th class="num">Túlfizetés</th><th class="num">Egyenleg</th></tr></thead>
      <tbody>
        <tr *ngFor="let e of o.egyenlegek">
          <td>{{ e.adonem }}</td><td>{{ e.adonem_szamla }}</td>
          <td>{{ e.befizeto_azonosito || '—' }}</td>
          <td class="num">{{ e.tartozas | number:'1.0-0' }}</td>
          <td class="num">{{ e.tulfizetes | number:'1.0-0' }}</td>
          <td class="num" [style.color]="e.egyenleg > 0 ? '#b91c1c' : '#15803d'">{{ e.egyenleg | number:'1.0-0' }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr style="font-weight:600;border-top:2px solid #cbd5e1">
          <td colspan="3">Összesen</td>
          <td class="num">{{ osszeg(o.egyenlegek, 'tartozas') | number:'1.0-0' }}</td>
          <td class="num">{{ osszeg(o.egyenlegek, 'tulfizetes') | number:'1.0-0' }}</td>
          <td class="num" [style.color]="osszeg(o.egyenlegek, 'egyenleg') > 0 ? '#b91c1c' : '#15803d'">{{ osszeg(o.egyenlegek, 'egyenleg') | number:'1.0-0' }}</td>
        </tr>
      </tfoot>
    </table>
    <p *ngIf="!o.egyenlegek?.length" class="halvany">Még nincs szinkronizált egyenleg ehhez az önkormányzathoz.</p>
  </div>
</div>

<ng-template #nincsUgyfel>
  <div class="ures"><ion-icon name="people-outline"></ion-icon> Válassz ügyfelet az e-Önkormányzat beállításához.</div>
</ng-template>

<!-- Hozzárendelés modal -->
<ion-modal #hozzarModal class="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar>
      <ion-title>{{ szerk?.id ? 'Önkormányzat szerkesztése' : 'Önkormányzat hozzárendelése' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="hozzarModal.dismiss()"><ion-icon name="close"></ion-icon></ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
      <ion-item *ngIf="!szerk.id">
        <ion-label position="stacked">Önkormányzat keresése a törzsből</ion-label>
        <ion-input placeholder="Kezdj el gépelni…" (ionInput)="torzsKeres($event)"></ion-input>
      </ion-item>
      <ion-list *ngIf="torzsTalalat.length" style="max-height:220px; overflow:auto">
        <ion-item button *ngFor="let t of torzsTalalat" (click)="torzsValaszt(t)">
          <ion-label>
            <strong>{{ t.nev }}</strong>
            <div style="font-size:.78rem; color:#64748b">{{ t.hivatalos_nev || t.megye }}</div>
          </ion-label>
        </ion-item>
      </ion-list>
      <p *ngIf="!szerk.id" class="halvany">Nincs a listában?
        <a style="color:var(--naplo); cursor:pointer" (click)="ujTorzs()">Önkormányzat felvétele a törzsbe</a>
      </p>

      <ion-item>
        <ion-label position="stacked">Kiválasztott önkormányzat</ion-label>
        <ion-input [value]="szerk.onkormanyzat_nev" readonly placeholder="—"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Belépési fiók (ügyfélkapu+)</ion-label>
        <ion-select [(ngModel)]="szerk.fiok_id" interface="popover" placeholder="Válassz fiókot">
          <ion-select-option *ngFor="let f of fiokok" [value]="f.id">{{ f.login }}{{ f.cimke && f.cimke !== f.login ? ' · ' + f.cimke : '' }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Adózó azonosítója (adószám / adóazonosító) – opcionális</ion-label>
        <ion-input [(ngModel)]="szerk.adoazonosito" placeholder="A portálon való azonosításhoz"></ion-input>
        <ion-button slot="end" size="small" fill="outline" (click)="tipusLekeres()" title="Típus + név lekérése a NAV-tól">
          <ion-icon slot="start" name="search"></ion-icon> NAV
        </ion-button>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Szerepkör a portálon (szerepkörváltáshoz)</ion-label>
        <ion-select [(ngModel)]="szerk.szerepkor" interface="popover" placeholder="Válassz szerepkört">
          <ion-select-option value="ceg">Cég / szervezet nevében</ion-select-option>
          <ion-select-option value="egyeni">Egyéni vállalkozóként</ion-select-option>
          <ion-select-option value="maganszemely">Magánszemélyként</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Szerepkör/adózó neve a portálon (ahogy a meghatalmazási listában szerepel)</ion-label>
        <ion-input [(ngModel)]="szerk.szerepkor_nev" placeholder="Pl. KOVÁCS JÁNOS E.V. vagy a cég neve"></ion-input>
      </ion-item>

      <ion-button expand="block" style="--background:var(--naplo); margin-top:16px" (click)="mentHozzar()">
        <ion-icon slot="start" name="save"></ion-icon> Mentés
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
